import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import view from './view';
import miloObject from '../../../common/object';
import miloCookie from '../../../common/cookie';
import miloUrl from '../../../common/url';
import Request from '../../../common/network';
import loginStatus from '../../../common/loginStatus';
import loader from '../../../common/loader';
import { isFunction, extend } from '../../../common/base';
import { getWgAuthUrl, getLoginInterFace, loginCookie, proxyManager, loginSvrCache } from '../common';
import './login.css';
var qcWxFrame = view.qcWxFrame,
    qqConnectFrame = view.qqConnectFrame,
    qqFrame = view.qqFrame,
    qqWxFrame = view.qqWxFrame,
    wegameFrame = view.wegameFrame,
    wxFrame = view.wxFrame;
export var pcParams = {
  // 公共的和显示相关的配置，每种登录还可以重新设置showParams到自己的配置项中，覆盖公共的showParams
  showParams: {
    topTips: '微信和QQ是两个独立账号，账号信息不互通',
    // qcwx和qqwx联合登录的时候上面的提示语
    zIndex: 999,
    // 登录弹框的zIndex值
    needMask: true,
    // 登录弹框是否需要遮罩
    canClose: true,
    // 登录框可以被手动关掉
    needReloadPage: true // 默认授权成功后刷新页面

  },

  /*
        @cfg {boolean} iPrivateLogin  是否私有登录态，如果为true，则不共享game.qq.com中的代理登录态，为false，则从game.qq.com中读取和写入登录态，默认为false
    */
  isPrivateLogin: false,

  /**
     * @cfg {number} iUseQQConnect 决定是否走QQ互联，1表示走QQ互联，0表示走PTLogin   [接受2种默认传参：顺序：  window >方法传参]
    */
  iUseQQConnect: typeof window.iUseQQConnect !== 'undefined' ? window.iUseQQConnect : 0,

  /**
     * @cfg {object} oQQParams Pt QQ登录相关配置参数
    */
  oQQParams: {
    appId: '21000501',
    // 官网默认的pt登录appid
    callback: null,
    // 登录成功后的回调
    sUrl: '',
    // 登录之后的跳转地址
    style: '20',
    innerParentId: '',
    showParams: {} // 会覆盖公共的showParams

  },

  /**
     * @cfg {object} oWXParams 微信登录相关配置参数
    */
  oWXParams: {
    appId: 'wxfa0c35392d06b82f',
    // 游戏在微信的appid，默认为腾讯游戏活动号
    gameDomain: 'iu.qq.com',
    lang: 'zh_CN',
    // 返回的用户信息中省市的语言版本
    callback: null,
    // 登录成功后的回调
    showParams: {} // 会覆盖公共的showParams

  },

  /**
     * @cfg {object} oQQConnectParams QQ互联登录方式相关参数
    */
  oQQConnectParams: {
    appId: '101491592',
    scope: 'get_user_info',
    state: 'STATE',
    redirectUri: 'https://milo.qq.com/comm-htdocs/login/qc_redirect.html',
    sUrl: '',
    // 登录之后的跳转地址
    callback: null,
    // 登录成功后的回调
    showParams: {} // 会覆盖公共的showParams

  },

  /**
     * @cfg {object} oWegameParams wegame互联登录方式相关参数
    */
  oWegameParams: {
    clientId: '7019928239',
    // 应用id
    redirectUri: 'https://milo.qq.com/comm-htdocs/login/wegame_redirect.html',
    // 回调地址
    railGameId: '2000108',
    // 游戏id
    scope: 'openid profile',
    // 作用域，可多选，空格分隔
    state: 'STATE',
    // 防csrf
    lang: 'ZH_CN',
    // 语言，默认为中文(ZH_CN)
    callback: null,
    // 登录成功后的回调
    showParams: {} // 会覆盖公共的showParams

  }
};
export var loginByQQ_PC = function loginByQQ_PC() {
  var loginParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var self = this; // 显示参数

  var _loginParams$showPara = loginParams.showParams,
      showParams = _loginParams$showPara === void 0 ? {} : _loginParams$showPara;

  if (1 === loginParams.iUseQQConnect) {
    // 互联登录
    this.loginByQQConnect(loginParams);
    return;
  }

  var ptOption = {
    appid: loginParams.appId,
    target: 'self',
    s_url: "".concat(location.protocol, "//").concat(window.location.host, "/comm-htdocs/login/logincallback.htm"),
    // 刷新页面的时候需要
    style: loginParams.style || '20',
    daid: 8
  };

  if (!/^'?(20|21|32|33)'?$/.test(ptOption.style)) {
    ptOption.style = '20';
  } // needReloadPage


  if (isFunction(loginParams.callback)) {
    showParams.needReloadPage = false;
  } // 跳转url


  if (showParams.needReloadPage) {
    loginParams.sUrl = loginParams.sUrl || location.href;
  } // 整体回调


  window.LoginedCallback = function () {
    if (showParams.needReloadPage) {
      if (location.href == loginParams.sUrl) {
        location.reload();
      } else {
        location.href = loginParams.sUrl;
      }
    } else {
      if (!loginParams.isQQWX) {
        // 非联合登录框
        qqFrame.close(true);
      }

      self.checkRealLogin().then(function (_ref) {
        var userInfo = _ref.userInfo,
            result = _ref.result;

        if (isFunction(loginParams.callback)) {
          loginParams.callback({
            isLogin: true,
            userInfo: userInfo,
            result: result
          });
        }
      })["catch"](function (errInfo) {
        if (isFunction(loginParams.callback)) {
          loginParams.callback({
            isLogin: false,
            errInfo: errInfo
          });
        }
      });
    }
  };

  var loginUrl = "https://xui.ptlogin2.qq.com/cgi-bin/xlogin?proxy_url=".concat(location.protocol, "//game.qq.com/comm-htdocs/milo/proxy.html&").concat(miloObject.serialize(ptOption));

  if (loginParams.innerParentId) {
    loginUrl += '&hide_close_icon=1';
    document.getElementById(loginParams.innerParentId).setAttribute('src', loginUrl);
  } else {
    if (!showParams.canClose) {
      loginUrl += '&hide_close_icon=1';
    }

    qqFrame.show(loginUrl, _objectSpread(_objectSpread({}, loginParams), {}, {
      showParams: showParams
    }));
  }
}; // QQ互联登录

export var loginByQQConnect_PC = function loginByQQConnect_PC() {
  var loginParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var self = this; // needReloadPage

  if (isFunction(loginParams.callback)) {
    loginParams.showParams.needReloadPage = false;
  }

  var _loginParams$showPara2 = loginParams.showParams,
      showParams = _loginParams$showPara2 === void 0 ? {} : _loginParams$showPara2; // 跳转url

  if (showParams.needReloadPage) {
    loginParams.sUrl = loginParams.sUrl || location.href;
  }

  var appId = loginParams.appId,
      redirectUri = loginParams.redirectUri,
      state = loginParams.state;
  var loginUrl = 'https://graph.qq.com/oauth2.0/authorize?response_type=code';
  var loginOpt = {
    state: state,
    client_id: appId,
    redirect_uri: "".concat(redirectUri).concat(redirectUri.indexOf('?') > -1 ? '&' : '?', "parent_domain=").concat(encodeURIComponent("".concat(location.protocol, "//").concat(location.host)))
  };
  loginUrl += "&".concat(miloObject.serialize(loginOpt));
  var isQcWx = !!loginParams.innerParentId; // 是否QCWX联合登录
  // 统一回调

  window.qqConnectCallback = function (codeOption) {
    if (!codeOption || !codeOption.code) {
      alert('抱歉，参数错误，请重新登录');

      if (isQcWx) {
        qcWxFrame.close();
      } else {
        qqConnectFrame.close();
      }

      return;
    }

    if (codeOption.state != loginParams.state) {
      alert('抱歉，来源校验错误，请重新登录');

      if (isQcWx) {
        qcWxFrame.close(true);
      } else {
        qqConnectFrame.close(true);
      }

      return;
    } // 请求codeToOpenid 拿openid和access_token
    // ......
    // need('util.jquery',function($){


    var params = {
      a: 'qcCodeToOpenId',
      qc_code: codeOption.code,
      appid: loginParams.appId,
      redirect_uri: loginParams.redirectUri
    };
    loginStatus.clearAME(function () {
      Request.ajax({
        url: "https://ams.game.qq.com/ams/userLoginSvr?".concat(miloObject.serialize(params)),
        type: 'GET',
        dataType: 'jsonp',
        success: function success(retObj) {
          if (0 === parseInt(retObj.iRet)) {
            var openid = retObj.openid,
                access_token = retObj.access_token,
                refresh_token = retObj.refresh_token;
            var expiresIn = retObj.expires_in || 86400;
            loginCookie.setLocal({
              acctype: 'qc',
              appid: appId,
              openid: openid,
              access_token: access_token,
              refresh_token: refresh_token
            }, expiresIn); // 同步登录态到game.qq.com

            proxyManager.set('qc', {
              appid: appId,
              openid: openid,
              access_token: access_token,
              refresh_token: refresh_token
            }, loginParams.isPrivateLogin, function () {}); // 判断是否需要刷新页面还是只想回调

            if (showParams.needReloadPage) {
              if (location.href == loginParams.sUrl) {
                location.reload();
              } else {
                location.href = loginParams.sUrl;
              }

              return;
            }

            if (isQcWx) {
              qcWxFrame.close(true);
            } else {
              qqConnectFrame.close(true);
            } // 校验登录态


            self.checkRealLogin().then(function (_ref2) {
              var userInfo = _ref2.userInfo,
                  result = _ref2.result;
              loginParams.callback({
                isLogin: true,
                userInfo: userInfo,
                result: result
              });
            })["catch"](function (errInfo) {
              loginParams.callback({
                isLogin: false,
                errInfo: errInfo
              });
            });
          } else {
            self.logout(function () {
              alert(retObj.sMsg);

              if (isQcWx) {
                qcWxFrame.close(true);
              } else {
                qqConnectFrame.close(true);
              }
            });
          }
        },
        error: function error() {}
      });
    });
  }; // 显示登录框


  if (isQcWx) {
    document.getElementById(loginParams.innerParentId).setAttribute('src', loginUrl);
  } else {
    qqConnectFrame.show(loginUrl, loginParams);
  }
};
export var loginByWX_PC = function loginByWX_PC() {
  var loginParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // 显示参数 serviceType暂时没有用，可删
  var showParams = loginParams.showParams,
      innerParentId = loginParams.innerParentId,
      appId = loginParams.appId,
      serviceType = loginParams.serviceType,
      gameDomain = loginParams.gameDomain,
      originalUrl = loginParams.originalUrl;
  var self = this; // redirect_uri

  var oriUrl = originalUrl || document.location.href;
  var url = "https://".concat(gameDomain || location.host, "/comm-htdocs/login/milosdk/wx_pc_redirect.html?appid=").concat(appId, "&sServiceType=").concat(serviceType, "&originalUrl=").concat(encodeURIComponent(oriUrl));
  var wxOption = {
    id: 'milo_wxLoginBox',
    appid: appId,
    scope: 'snsapi_login',
    redirect_uri: encodeURIComponent(url),
    state: '1',
    style: 'black',
    href: '',
    self_redirect: true
  };

  var getWxLoginApi = function getWxLoginApi(callback) {
    if (isFunction(window.WxLogin)) {
      callback(window.WxLogin);
    } else {
      loader.loadScript("".concat(location.protocol, "//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js")).then(function (loaded) {
        if (!loaded) {
          callback(null);
          return;
        }

        isFunction(callback) && callback(window.WxLogin);
      });
    }
  }; // 拿到wxlogin对象api


  getWxLoginApi(function (WxLogin) {
    if (innerParentId) {
      // 内置
      wxOption.id = innerParentId; // eslint-disable-next-line no-unused-vars

      new WxLogin(wxOption);
    } else {
      // 单独微信登录
      wxFrame.init(function () {
        // eslint-disable-next-line no-unused-vars
        new WxLogin(wxOption);
        wxFrame.show(extend(loginParams, {
          showParams: showParams
        }));
      });
    }
  }); // 全局统一回调

  window.milo_WxLoginCallback = function (_ref3) {
    var wxcode = _ref3.wxcode,
        appid = _ref3.appid,
        originalUrl = _ref3.originalUrl,
        wxcodedomain = _ref3.wxcodedomain;

    // 关闭弹框
    if (loginParams.isQCWX) {
      // qcwx
      qcWxFrame.close(true);
    } else if (loginParams.isQQWX) {
      // qqwx
      qqWxFrame.close(true);
    } else {
      wxFrame.close(true);
    }

    var codeToOpenIdUrl = getLoginInterFace({
      acctype: 'wx',
      type: 'codetoopenid'
    }); // 执行codeToOpenId

    loginStatus.clearAME(function () {
      Request.ajax({
        url: codeToOpenIdUrl,
        type: 'GET',
        dataType: 'jsonp',
        data: {
          appid: appid,
          wxcode: wxcode,
          originalUrl: originalUrl,
          wxcodedomain: wxcodedomain,
          acctype: 'wx',
          sServiceType: 'undefined'
        },
        success: function success(retObj) {
          if (0 === parseInt(retObj.iRet)) {
            var objData = JSON.parse(retObj.sMsg); // 设置cookie

            var _ref4 = objData || {},
                access_token = _ref4.access_token,
                expires_in = _ref4.expires_in,
                openid = _ref4.openid,
                refresh_token = _ref4.refresh_token;

            loginCookie.setLocal({
              acctype: 'wx',
              openid: openid,
              appid: appid,
              access_token: access_token,
              refresh_token: refresh_token
            }, expires_in); // 设置登录态同步到game.qq.com

            proxyManager.set('wx', {
              appid: appid,
              openid: openid,
              access_token: access_token,
              refresh_token: refresh_token
            }, loginParams.isPrivateLogin, function () {});

            if (!isFunction(loginParams.callback)) {
              if (location.href == oriUrl) {
                location.reload();
              } else {
                location.href = oriUrl;
              }

              return;
            } // 校验登录态


            self.checkRealLogin().then(function (_ref5) {
              var userInfo = _ref5.userInfo,
                  result = _ref5.result;
              loginParams.callback({
                isLogin: true,
                userInfo: userInfo,
                result: result
              });
            })["catch"](function (errInfo) {
              loginParams.callback({
                isLogin: false,
                errInfo: errInfo
              });
            });
          } else {
            alert('获取登录态失败');
          }
        },
        fail: function fail() {
          alert('获取登录态失败');
        }
      });
    });
  };
}; // wegame登录

export var loginByWegame_PC = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var loginParams,
        self,
        _loginParams$showPara3,
        showParams,
        wgauth,
        wgOneAuth,
        state,
        clientId,
        railGameId,
        lang,
        scope,
        redirectUri,
        loginOpt,
        loginUrl,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loginParams = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            self = this; // 显示参数

            _loginParams$showPara3 = loginParams.showParams, showParams = _loginParams$showPara3 === void 0 ? {} : _loginParams$showPara3, wgauth = loginParams.wgauth; // 是否开启一键登录

            wgOneAuth = wgauth == 1 || miloUrl.request('wgauth') == 1; // needReloadPage

            if (isFunction(loginParams.callback)) {
              showParams.needReloadPage = false;
            } // 跳转url


            if (showParams.needReloadPage) {
              loginParams.sUrl = loginParams.sUrl || location.href;
            } // 统一回调


            window.wegameCallback = function (codeOption) {
              wegameFrame.showTitle(true);

              if (!codeOption || !codeOption.code) {
                alert('抱歉，参数错误，请重新登录');
                wegameFrame.close();
                return;
              }

              if (codeOption.state != loginParams.state) {
                alert('抱歉，来源校验错误，请重新登录');
                wegameFrame.close();
                return;
              }

              var clientId = loginParams.clientId,
                  redirectUri = loginParams.redirectUri,
                  isPrivateLogin = loginParams.isPrivateLogin,
                  sUrl = loginParams.sUrl; // code换取access_token和openid等

              var params = {
                a: 'wgCodeToRailId',
                wg_code: codeOption.code,
                appid: clientId,
                redirect_uri: redirectUri
              };
              loginStatus.clearAME(function () {
                Request.ajax({
                  url: "https://ams.game.qq.com/ams/userLoginSvr?".concat(miloObject.serialize(params)),
                  type: 'GET',
                  dataType: 'jsonp',
                  success: function success(retObj) {
                    if (0 === parseInt(retObj.iRet)) {
                      var data = retObj || {};
                      var expiresIn = data.expires_in || 3600;
                      var openid = data.openid,
                          access_token = data.access_token,
                          refresh_token = data.refresh_token;
                      loginCookie.setLocal({
                        acctype: 'wg',
                        appid: clientId,
                        openid: openid,
                        access_token: access_token,
                        refresh_token: refresh_token
                      }, expiresIn); // 设置登录态同步到game.qq.com

                      proxyManager.set('wg', {
                        appid: clientId,
                        openid: openid,
                        access_token: access_token,
                        refresh_token: refresh_token
                      }, isPrivateLogin, function () {}); // 判断是否需要刷新页面还是只想回调

                      if (showParams.needReloadPage) {
                        if (location.href === sUrl) {
                          location.reload();
                        } else {
                          location.href = sUrl;
                        }

                        return;
                      } // 校验登录态


                      wegameFrame.close();
                      self.checkRealLogin().then(function (_ref7) {
                        var userInfo = _ref7.userInfo,
                            result = _ref7.result;
                        loginParams.callback({
                          isLogin: true,
                          userInfo: userInfo,
                          result: result
                        });
                      })["catch"](function (errInfo) {
                        loginParams.callback({
                          isLogin: false,
                          errInfo: errInfo
                        });
                      });
                    } else {
                      self.logout(function () {
                        alert(retObj.sMsg);
                        wegameFrame.close();
                      });
                    }
                  },
                  error: function error() {
                    alert('获取登录态失败');
                  }
                });
              });
            };

            state = loginParams.state, clientId = loginParams.clientId, railGameId = loginParams.railGameId, lang = loginParams.lang, scope = loginParams.scope, redirectUri = loginParams.redirectUri;
            loginOpt = {
              redirect_type: 'self',
              state: state,
              client_id: clientId,
              rail_game_id: railGameId,
              lang: lang,
              scope: scope,
              redirect_uri: redirectUri
            };
            loginUrl = "https://api.rail.tgp.qq.com/web/oauth2.0/login/authorize?response_type=code&".concat(miloObject.serialize(loginOpt));

            if (!wgOneAuth) {
              _context.next = 21;
              break;
            }

            _context.prev = 11;
            _context.next = 14;
            return getWgAuthUrl(loginParams);

          case 14:
            loginUrl = _context.sent;
            loginUrl = "".concat(loginUrl).concat(loginUrl.indexOf('?') > -1 ? '&' : '?', "state=").concat(state);
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](11);
            console.log('一键登录Url获取失败');

          case 21:
            miloCookie.set('milo_wegame_domain', "".concat(location.protocol, "//").concat(location.host), 0, 'qq.com', '/');
            wegameFrame.show(loginUrl, _objectSpread(_objectSpread({}, loginParams), {}, {
              showParams: showParams
            }));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[11, 18]]);
  }));

  return function loginByWegame_PC() {
    return _ref6.apply(this, arguments);
  };
}(); // QC微信联合登录

export var loginByQQConnectAndWX_PC = function loginByQQConnectAndWX_PC() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var self = this; // 显示参数

  var showParams = opt.showParams,
      loginParamsQC = opt.oQQConnectParams,
      loginParamsWX = opt.oWXParams,
      callback = opt.callback;
  qcWxFrame.init({
    oQQConnectParams: loginParamsQC,
    oWXParams: loginParamsWX,
    showParams: showParams
  }, function () {
    var oQCParams = _objectSpread(_objectSpread({}, loginParamsQC), {}, {
      innerParentId: 'milo-qcwx-frame-qc',
      isQCWX: true,
      callback: callback
    });

    var oWXParams = _objectSpread(_objectSpread({}, loginParamsWX), {}, {
      innerParentId: 'milo-qcwx-frame-wx-div',
      isQCWX: true,
      callback: callback
    });

    loginByQQConnect_PC.call(self, oQCParams);
    loginByWX_PC.call(self, oWXParams);
    qcWxFrame.show({
      oQQConnectParams: loginParamsQC,
      oWXParams: loginParamsWX,
      showParams: showParams
    });
  });
}; // QQ微信联合登录

export var loginByQQAndWX_PC = function loginByQQAndWX_PC() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // 显示参数
  var self = this;
  var showParams = opt.showParams,
      loginParamsQQ = opt.oQQParams,
      loginParamsWX = opt.oWXParams,
      callback = opt.callback; // 是否使用QQ互联

  if (1 === loginParamsQQ.iUseQQConnect) {
    loginByQQConnectAndWX_PC(_objectSpread(_objectSpread({}, opt), {}, {
      oQQConnectParams: loginParamsQQ
    }));
    return;
  }

  qqWxFrame.init({
    oQQParams: loginParamsQQ,
    oWXParams: loginParamsWX,
    showParams: showParams
  }, function () {
    var oQQParams = _objectSpread(_objectSpread({}, loginParamsQQ), {}, {
      innerParentId: 'milo-qqwx-frame-qq',
      isQQWX: true,
      callback: callback
    });

    var oWXParams = _objectSpread(_objectSpread({}, loginParamsWX), {}, {
      innerParentId: 'milo-qqwx-frame-wx-div',
      isQQWX: true,
      callback: callback
    });

    loginByQQ_PC.call(self, oQQParams);
    loginByWX_PC.call(self, oWXParams);
    qqWxFrame.show({
      oQQParams: loginParamsQQ,
      oWXParams: loginParamsWX,
      showParams: showParams
    });
  });
};
export var refreshWegame_PC = function refreshWegame_PC(_success, _fail) {
  var self = this;

  var _self$getLoginStatusP = self.getLoginStatusParams(),
      acctype = _self$getLoginStatusP.acctype,
      appid = _self$getLoginStatusP.appid,
      refresh_token = _self$getLoginStatusP.refresh_token;

  if (!refresh_token || !appid || 'wg' != acctype) {
    isFunction(_fail) && _fail('抱歉，请重新登录。');
    return;
  }

  var loginUrl = getLoginInterFace({
    type: 'checkLogin'
  });
  var params = {
    appid: appid,
    acctype: acctype,
    refresh_token: refresh_token
  };
  loginStatus.clearAME(function () {
    Request.ajax({
      url: loginUrl,
      dataType: 'jsonp',
      data: params,
      success: function success(retObj) {
        if (0 == retObj.errorCode && retObj.isLogin) {
          var expires_in = retObj.expires_in || 3600;
          var openid = retObj.openid,
              access_token = retObj.access_token,
              _refresh_token = retObj.refresh_token;
          loginCookie.setLocal({
            openid: openid,
            access_token: access_token,
            refresh_token: _refresh_token
          }, expires_in); // 缓存

          var id = "wg_".concat(openid);
          loginSvrCache.set(id, retObj); // 获取用户信息

          self.getUserInfo({
            success: function success(userInfo) {
              // 设置cookie缓存登录态
              var IED_LOG_INFO_NEW = {};
              IED_LOG_INFO_NEW.acctype = acctype;
              IED_LOG_INFO_NEW.openid = userInfo.openid;
              IED_LOG_INFO_NEW.nickName = userInfo.nickName;
              IED_LOG_INFO_NEW.avatarUrl = userInfo.avatarUrl;
              loginCookie.setSession({
                IED_LOG_INFO_NEW: miloObject.serialize(IED_LOG_INFO_NEW)
              }); // 登录成功，获取用户信息成功 result：登录返回   userInfo:用户信息

              isFunction(_success) && _success({
                isLogin: true,
                retObj: retObj,
                userInfo: userInfo
              });
            },
            fail: function fail() {
              // 登录成功，获取用户信息失败,result：登录返回
              isFunction(_success) && _success({
                isLogin: true,
                retObj: retObj
              });
            }
          });
        } else {
          isFunction(_fail) && _fail(retObj);
        }
      },
      fail: function fail() {
        isFunction(_fail) && _fail('抱歉，请重新登录。');
      }
    });
  });
};